import { useSyncExternalStore } from 'react';

const read = () => new Date().toTimeString().slice(0, 8);

let current = read();
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | undefined;

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (listeners.size === 1) {
    current = read();
    timer = setInterval(() => {
      const next = read();
      if (next === current) return;
      current = next;
      for (const l of listeners) l();
    }, 250);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) clearInterval(timer);
  };
}

/** Local wall-clock time as "HH:MM:SS"; every consumer shares one timer. */
export function useClock(): string {
  return useSyncExternalStore(subscribe, () => current);
}
